import appConfig from 'app-config';

export type CampaignId =
  | 'web_to_app_who_viewed_me'
  | 'web_to_app_home'
  | 'web_to_app_effect'
  | 'web_to_app_message'
  /**
   * 얼굴 인증이 강제되나 해당 웹클라서 이를 지원하지 못해 앱으로 강제 이동시키는 경우
   */
  | 'web_to_app_face_verify'
  /**
   * 얼굴 인증에 실패하여 앱으로 유도시키는 경우 (브라우저(특히 데스크톱) 보다 성공률이 높은 앱에서 다시 인증 유도)
   */
  | 'web_to_app_liveness_failed'
  /**
   * 얼굴 인증이 오래걸려 앱으로 유도시키는 경우 (앱에서 로그인 후 푸시알림을 받도록 유도)
   */
  | 'web_to_app_liveness_pending'
  /**
   * 얼굴 인증이 강제되나 해당 웹클라서 이를 지원하지 못해 앱으로 유도하는 경우
   */
  | 'web_to_app_overconstrained'
  | 'web_to_app_unsupported_browser';
export function getWebToAppUrl(campaignId: CampaignId) {
  const url = new URL(appConfig.webToAppModalConfig.url);

  if (appConfig.webToAppModalConfig.shouldInjectCampaignId ?? false) {
    /**
     * c 파라미터는 AppsFlyer 캠페인 아이디를 의미합니다.
     */
    url.searchParams.append('c', campaignId);
  }

  return url;
}
